import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { VerifikasiWilkerPenyuluh } from './types'
import type {
  ApprovalNoteValues,
  FilterVerifikasiWilkerValues
} from './validation'

const QUERY_KEY = (key?: string | Record<string, unknown>) =>
  ['verifikasi-wilker-penyuluh', key] as const

const getAll = (
  params?: FilterVerifikasiWilkerValues
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<VerifikasiWilkerPenyuluh>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const search = params?.s?.trim() || params?.search?.trim() || undefined

      const response = await api.get<
        ServiceGetAllResponse<Array<VerifikasiWilkerPenyuluh>>
      >('/verifikasi-wilker-penyuluh', {
        params: {
          page: params?.page,
          per_page: params?.per_page,
          status: params?.status,
          s: search
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getById = (
  id: string
): ServiceQueryOptionType<
  ServiceGetByIdResponse<VerifikasiWilkerPenyuluh>
> => ({
  queryKey: QUERY_KEY(id),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<VerifikasiWilkerPenyuluh>
      >(`/verifikasi-wilker-penyuluh/${id}`)

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const approve = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<VerifikasiWilkerPenyuluh>,
  ApprovalNoteValues
> => ({
  mutationFn: async (data: ApprovalNoteValues) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<VerifikasiWilkerPenyuluh>
      >(`/verifikasi-wilker-penyuluh/${data.id}/approve`, {
        approval_note: data.approval_note || undefined
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const reject = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<VerifikasiWilkerPenyuluh>,
  ApprovalNoteValues
> => ({
  mutationFn: async (data: ApprovalNoteValues) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<VerifikasiWilkerPenyuluh>
      >(`/verifikasi-wilker-penyuluh/${data.id}/reject`, {
        approval_note: data.approval_note || undefined
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const verifikasiWilkerPenyuluh = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  getById,
  approve,
  reject
}
